<div class="flex justify-between items-center flex-wrap gap-1 mb-1">
  <nz-radio-group [(ngModel)]="quickFilter" (ngModelChange)="filterData()" nzButtonStyle="outline">
    <label nz-radio-button nzValue="all" class="font-semibold radio-button-primary">
      <i nz-icon nzType="unordered-list" nzTheme="outline" class="mr-2"></i>
      All {{counts.total_count}}
    </label>
    <label nz-radio-button nzValue="active" class="font-semibold radio-button-success">
      <i nz-icon nzType="hezky:Gateway" nzTheme="outline" class="mr-2"></i>
      Active {{counts.active_count}}
    </label>
    <label nz-radio-button nzValue="inActive" class="font-semibold radio-button-warning">
      <span class="text-[9px] text-[#B7B7B7]">x</span>
      <i class="mr-2" style="font-size: 14px !important;color: rgb(176, 180, 180);" nz-icon
        [nzType]="'hezky:Signal'"></i>
      Inactive {{counts.inactive_count}}
    </label>
  </nz-radio-group>
  <nz-page-header-extra>
    <nz-space>
      <nz-input-group class="mr-1" [nzPrefix]="searchIcon">
        <input nz-input class="w-full" type="search" [(ngModel)]="searchText" placeholder="Search here..."
          (ngModelChange)="getSearchDetails(searchText)">
      </nz-input-group>
      <ng-template #searchIcon>
        <span nz-icon nzType="search" aria-hidden="true"></span>
      </ng-template>
      <button nz-button class="mr-1" nzType="default" type="button" [nzTooltipColor]="'#fff'" nz-tooltip
        nzTooltipTitle="Refresh" [nzShape]="'circle'" (click)="refreshHandler()">
        <i nz-icon nzType="reload"></i>
      </button>
      <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="showModal('excel')"><i nz-icon
          nzType="plus"></i>Add Excel</button>
      <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="showModal('hooter')"><i nz-icon
          nzType="plus"></i>Add Hooter</button>
    </nz-space>
  </nz-page-header-extra>
</div>

<nz-table #hootersTable nzShowSizeChanger [nzLoading]="this.apiCallLoaders['isHootersLoading']"
  [nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'" [nzShowTotal]="totalTemplate"
  [nzData]="filteredHooterList$">
  <thead>
    <tr>
      <th *ngFor="let column of listOfColumns" nzEllipsis="..."> {{column.name}}</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let hooter of hootersTable.data; let i = index; trackBy: commonService.trackByFn">
      <td nzEllipsis="...">
        <button nzType="default" class="text-[#fff] px-2 py-1 rounded-lg"
          [ngClass]="{'bg-[#008001]' : hooter?.is_active, 'bg-danger'  : !hooter?.is_active}">
          <span *ngIf="hooter?.is_active" class="mr-1" style="font-size: 14px !important" nz-icon
            [nzType]="'hezky:Gateway'"></span>
          {{ hooter?.is_active ? 'Online' : 'Offline' }}
        </button>
      </td>
      <td nzEllipsis="...">{{ hooter?.hooter_name }}</td>
      <td nzEllipsis="...">{{ hooter?.deviceeui}}</td>
      <td nzEllipsis="...">{{ hooter?.model_number}}</td>
      <td nzEllipsis="...">{{ hooter?.serial_number}}</td>
      <td nzEllipsis="...">{{ hooter?.display_name }}</td>

      <td nzEllipsis="...">
        <span nz-tooltip="Edit" [nzTooltipColor]="'#fff'" nz-icon nzType="edit" nzTheme="outline"
          class="text-base text-primary cursor-pointer" (click)="editHooter(hooter)"></span>
        <span nz-tooltip="Delete" [nzTooltipColor]="'#fff'" nz-icon nzType="delete" nzTheme="outline"
          class="text-base text-danger cursor-pointer ml-5" nz-popconfirm nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?"
          (nzOnConfirm)="deleteHooter(hooter.idt_hooter)"></span>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isExcelModalVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel('excel')"
  [nzWidth]="550">
  <ng-template #modalTitle>
    <div class="flex justify-between items-center">
      <span class="text-lg font-medium">Add Excel</span>
      <a *ngIf="excelErrLink" (click)="downloadLogFile()"
        class="text-blue-600 font-bold cursor-pointer hover:underline">
        <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
        Download Log
      </a>
    </div>
  </ng-template>

  <ng-template #excelContent>
    <ng-container>
      <div *ngIf="excelErr && !isSuccessMessage"
        class="mb-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded-md">
        <strong>Error:</strong> {{ excelErr }}
      </div>

      <!-- Success Message -->
      <div *ngIf="excelErr && isSuccessMessage"
        class="mb-4 p-3 bg-green-50 text-green-700 border border-green-200 rounded-md">
        <strong>Success:</strong> {{ excelErr }}
      </div>

      <div *ngIf="!excelErrLink" class="mb-3 text-center flex justify-end">
        <a class="cursor-pointer hover:underline text-blue-600 font-bold" nz-popconfirm (nzOnConfirm)="downloadTemplate()"
          nzPopconfirmTitle="Are you sure to download this template file?" nzPopconfirmPlacement="bottom">
          <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
          Download Template
        </a>
      </div>

      

    
      
      <div
        class="upload-container border-2 border-dashed border-gray-300 bg-white p-6 rounded-lg mb-4 text-center hover:border-blue-400 transition-colors">
        <label for="excelFile" class="custom-file-upload w-full block cursor-pointer">
          <i nz-icon nzType="upload" nzTheme="outline" class="text-primary text-[32px] block mb-3"></i>
          <input #addHooterFile type="file" id="excelFile" (change)="onFileChange($event)" accept=".xls,.xlsx"
            class="hidden">
          <p class="ant-upload-text font-medium mb-2 text-base">Click or drag file to this area to upload</p>
          <p class="ant-upload-hint text-gray-500">File headers should match, and all fields must have appropriate data.
          </p>
        </label>
      </div>
      <div class="uploaded-files" *ngIf="fileList.length > 0">
        <h4 class="text-sm font-medium mb-3 text-gray-700 pl-1">Uploaded Files</h4>
        <div *ngFor="let file of fileList; let i = index"
          class="uploaded-file flex items-center justify-between p-3 mb-3 bg-white border border-gray-300 rounded-md hover:shadow-sm transition-shadow">
          <div class="flex items-center">
            <i nz-icon [nzType]="file.name.toLowerCase().endsWith('.xlsx') ? 'file-excel' : 'file-excel'"
              nzTheme="twotone" class="mr-3 text-lg"></i>
            <span class="filename font-medium">{{ file?.name }}</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="filesize text-sm text-gray-600">
              {{ (file.size / 1024 / 1024).toFixed(2) }} MB
            </span>
            <button type="button" nz-button nzType="text" nzDanger (click)="removeFile(i)"
              class="flex items-center justify-center p-1 hover:bg-red-50 rounded-full">
              <i nz-icon nzType="delete"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #excelFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button nz-button nzType="default" (click)="handleCancel('excel')" class="px-5 py-1 h-9">Cancel</button>
      <button nz-button nzType="primary" (click)="onExcelSubmit()" [nzLoading]="isConfirmLoading"
        class="px-5 py-1 h-9">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="excelContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="excelFooter"></ng-container>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isHooterModalVisible" [nzTitle]="isEditMode ? 'Edit Hooter' : 'Add New Hooter'"
  (nzOnCancel)="handleCancel('hooter')" [nzWidth]="600">
  <ng-template #hooterContent>
    <form nz-form [formGroup]="form" [nzLayout]="'vertical'" role="form" aria-labelledby="form" class="p-4">
      <div class="space-y-4">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="hooter_name" class="pb-1 text-base">Hooter Name</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Hooter Name is required'">
            <input nz-input formControlName="hooter_name" class="w-full py-2 px-3 rounded-md" maxlength="100"
              placeholder="Enter Hooter Name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="model_no" class="pb-1 text-base">Model Number</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Hooter Model is required'">
            <nz-select formControlName="model_no" nzPlaceHolder="Select Model Number" class="w-full" nzShowSearch
              nzShowArrow="false">
              <nz-option *ngFor="let model of modelNumber" [nzValue]="model.model_number"
                [nzLabel]="model.model_number"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="deviceeui" class="pb-1 text-base">Hooter EUI
            No.</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Hooter EUI Number is required'">
            <nz-select formControlName="deviceeui" nzPlaceHolder="Select Hooter EUI" class="w-full" nzShowSearch
              nzShowArrow="false">
              <nz-option *ngFor="let device of deviceEUI" [nzValue]="device.device_ui" [nzLabel]="device.device_ui">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <div class="grid grid-cols-2 gap-4">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired nzFor="gateway_id" class="pb-1 text-base">Gateway
              Name</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzErrorTip]="'Gateway Name is required'">
              <nz-select formControlName="gateway_id" nzPlaceHolder="Select Gateway" class="w-full" nzShowSearch
                nzShowArrow="false">
                <nz-option *ngFor="let gateway of gatewaysByLocation" [nzValue]="gateway.gateway_id"
                  [nzLabel]="gateway.gateway_name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired nzFor="location_id" class="pb-1 text-base">Location</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzMode="default" formControlName="location_id" nzPlaceHolder="Select Location" class="w-full"
                nzShowSearch nzShowArrow="false">
                <nz-option *ngFor="let location of locationOptions" [nzValue]="location.location_id"
                  [nzLabel]="location.display_name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #hooterFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button nz-button nzType="default" (click)="handleCancel('hooter')" class="px-5 py-1 h-9">Cancel</button>
      <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="isConfirmLoading" class="px-5 py-1 h-9">
        {{ isEditMode ? 'Update' : 'Submit' }}
      </button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="hooterContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="hooterFooter"></ng-container>
  </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>